<template>
  <div class="el-section">
    <div
      class="emd-container _highlight_header _header_spaced _footer_spaced_sm"
    >
      <div class="emd-container__header">
        <h2 class="emd-text _size_section">
          {{ $t('customer.subscriptions.title') }}
        </h2>
      </div>
      <div
        v-if="loadingList"
        class="eu-pa_6 eu-align_center"
      >
        <emd-loader :type="'_invert'"></emd-loader>
      </div>
      <div
        v-else
        class="emd-table-responsive"
      >
        <Table
          :fields="fields"
          :items="subscriptions.items"
          :toDetail="permissionIsEnabled('subscription:get') && toDetail"
        ></Table>
        <empty-list
          v-if="!loadingList && showEmptyList()"
          entity="subscriptions"
        ></empty-list>
      </div>
      <pagination
        v-if="!loadingList"
        :pagination="subscriptions.pagination"
        :totalShowing="totalItems"
        :type="'list'"
        :action="action"
      ></pagination>
    </div>
  </div>
</template>
<script>
import { EmdLoader } from 'emerald-vue/src/components'
import EmptyList from '@/components/project/globals/EmptyList.vue'
import Pagination from '@/components/project/globals/Pagination.vue'
import Table from '@/components/project/molecules/Table.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'CustomerSubscriptions',
  components: {
    EmdLoader,
    EmptyList,
    Pagination,
    Table
  },
  data () {
    return {
      action: 'GET_SUBSCRIPTIONS',
      fields: [
        {
          id: 'code',
          label: 'customer.subscriptions.code',
          type: 'text'
        },
        {
          id: 'plan.name',
          label: 'customer.subscriptions.plan',
          type: 'text'
        },
        {
          id: 'status',
          label: 'customer.subscriptions.status',
          type: 'status'
        },
        {
          id: 'billing_type',
          label: 'customer.subscriptions.billing-type',
          type: 'text'
        },
        {
          id: 'start_at',
          label: 'customer.subscriptions.start-at',
          type: 'date',
          format: 'date'
        },
        {
          id: 'created_at',
          label: 'customer.subscriptions.created-at',
          type: 'date',
          format: 'dateAndHour'
        }
      ],
      toDetail: {
        name: 'subscriptionsDetail',
        params: {
          id: 'id',
          tab: 'info'
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'merchant',
      'account',
      'subscriptions',
      'loadingListSubscriptions',
      'permissionIsEnabled'
    ]),
    totalItems () {
      return this.subscriptions.items.length
    },
    loadingList () {
      return this.loadingListSubscriptions
    }
  },
  created () {
    const query = {
      customer_id: this.$route.params.id,
      page: this.$route.query.page || 1
    }
    const params = {
      merchantId: this.merchant.id,
      accountId: this.account.id,
      query
    }
    this.$router.replace({ query: query }).catch(err => err)
    this.$store.dispatch('GET_SUBSCRIPTIONS', params)
  },

  methods: {
    showEmptyList () {
      return (
        !this.loadingList &&
        this.subscriptions.pagination &&
        this.subscriptions.pagination.total_items === 0
      )
    }
  }
}
</script>
